import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface DeliveryAreaDiscounts {
    area_code_name(area_code_name: any): unknown;
    discount_value: any;
    delivery_charge(delivery_charge: any): unknown;
    description: any;
    discount_type: any;
}
type DeliveryAreaDiscountsResponse = {
    data: {
        data: DeliveryAreaDiscounts[];
        count: number;
        status: string;
        payload?: any;
    };
    isSuccess: boolean;
    status: number;
};

interface DeliveryAreaDiscountssState {
    data: DeliveryAreaDiscounts[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

export const fetchDeliveryAreaDiscounts = createAsyncThunk<
    DeliveryAreaDiscounts[],
    void,
    { rejectValue: string }
>(
    'DeliveryAreaDiscounts/fetchDeliveryAreaDiscounts',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<DeliveryAreaDiscountsResponse>(
                '/get_all_delivery_area_discounts',
                PORT,
                URL
            );

            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'An error occurred'
            );
        }
    }
);


export const createDeliveryAreaDiscounts = createAsyncThunk<DeliveryAreaDiscounts, any, { rejectValue: string }>(
    'DeliveryAreaDiscounts/createDeliveryAreaDiscounts',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: DeliveryAreaDiscounts }>('create_delivery_area_discount', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateDeliveryAreaDiscounts = createAsyncThunk<DeliveryAreaDiscounts, any, { rejectValue: string }>(
    'DeliveryAreaDiscounts/updateDeliveryAreaDiscounts',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: DeliveryAreaDiscounts }>('update_delivery_area_discount', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const softDeleteDeliveryAreaDiscounts: any = createAsyncThunk<
    number,
    number
>(
    "DeliveryAreaDiscounts/softDeleteDeliveryAreaDiscounts",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `delete_delivery_area_discount?id=${id}`,
                {},
               PORT, URL
            );
            return response
        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting Settings Key"
            );
        }
    }
);
export const DeliveryAreaDiscountsSlice = createSlice({
    name: 'DeliveryAreaDiscounts',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as DeliveryAreaDiscountssState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDeliveryAreaDiscounts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDeliveryAreaDiscounts.fulfilled, (state, action: PayloadAction<DeliveryAreaDiscounts[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchDeliveryAreaDiscounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createDeliveryAreaDiscounts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createDeliveryAreaDiscounts.fulfilled, (state, action: PayloadAction<DeliveryAreaDiscounts>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createDeliveryAreaDiscounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateDeliveryAreaDiscounts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateDeliveryAreaDiscounts.fulfilled, (state, action: PayloadAction<DeliveryAreaDiscounts>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateDeliveryAreaDiscounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
           
    },
});

export default DeliveryAreaDiscountsSlice.reducer;